'use client';

import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import Text from '../Text/Text';
import styles from './Countdown.module.scss';

const Countdown = ({ endDateString }: { endDateString: string }) => {
  const t = useTranslations('countdown');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    if (!endDateString) {
      return;
    }
    const endDate = new Date(endDateString);
    const calculateTimeLeft = () => {
      // Check if endDate exists and is valid
      if (!endDate || Number.isNaN(endDate.getTime())) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
        return;
      }

      const now = Date.now();
      const difference = endDate.getTime() - now;

      if (difference > 0) {
        // Calculate the time left
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({
          days,
          hours,
          minutes,
          seconds,
        });
      } else {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [endDateString]);

  const formatTime = (value: number) => value.toString().padStart(2, '0');

  return (
    <section className={styles.countdownContainer}>
      <div className={styles.title}>
        <Text
          tag='h3'
          className={styles.title}
        >
          {'Limited slots available for our first production run - \n**secure yours today.**'}
        </Text>
      </div>
      <div className={styles.countdown}>
        <div className={styles.countdownItem}>
          <Text tag='h1'>
            {formatTime(timeLeft.days)}
          </Text>
          <h4>{t('days')}</h4>
        </div>
        <div className={styles.countdownItem}>
          <Text tag='h1'>
            {formatTime(timeLeft.hours)}
          </Text>
          <h4>{t('hours')}</h4>
        </div>
        <div className={styles.countdownItem}>
          <Text tag='h1'>
            {formatTime(timeLeft.minutes)}
          </Text>
          <h4>{t('minutes')}</h4>
        </div>
        <div className={styles.countdownItem}>
          <Text tag='h1'>
            {formatTime(timeLeft.seconds)}
          </Text>
          <h4>{t('seconds')}</h4>
        </div>
      </div>
    </section>
  );
};

export default Countdown;
